<template>
  <div class="container">
    <div class="card card-a">
      <div class="info info-a">
        <h3 class="tittle">Grow Together</h3>
        <p class="description">
          Generate meaningful discussions with your audience and build a strong,
          loyal community. Think of the insightful conversations you miss out on
          with a feedback form.
        </p>
      </div>
      <img src="../assets/illustration-grow-together.svg" alt="grow image" />
    </div>

    <div class="card card-b">
      <div class="info info-b">
        <h3 class="tittle">Flowing Conversations</h3>
        <p class="description">
          You wouldn't paginate a conversation in real life, so why do it
          online? Our threads have just-in-time loading for a more natural flow.
        </p>
      </div>
      <img
        src="../assets/illustration-flowing-conversation.svg"
        alt="grow image"
      />
    </div>

    <div class="card card-c">
      <div class="info info-c">
        <h3 class="tittle">Your Users</h3>
        <p class="description">
          It takes no time at all to integrate Huddle with your app's
          authentication solution. This means, once signed in to your app, your
          users can start chatting immediately.
        </p>
      </div>
      <img src="../assets/illustration-your-users.svg" alt="grow image" />
    </div>
  </div>
</template>

<script>
export default {
  setup() {},
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Poppins:wght@600&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;700&display=swap");
* {
  margin: 0;
  padding: 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.container {
  padding-top: 35px;
  padding-bottom: 35px;
  width: 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}

.card {
  text-align: center;
  width: 90%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: reverse;
  -ms-flex-direction: column-reverse;
  flex-direction: column-reverse;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  margin-top: 30px;
  padding: 25px;
  border-radius: 15px;
  -webkit-box-shadow: 0 0 10px rgba(128, 141, 153, 0.3);
  box-shadow: 0 0 10px rgba(128, 141, 153, 0.3);
}

.card img {
  width: 95%;
  margin-top: 40px;
}

.info {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  margin-top: 50px;
}

.tittle {
  font-family: "Poppins", sans-serif;
}

.description {
  margin-top: 30px;
  width: 290px;
  opacity: 0.7;
  font-family: "Open Sans", sans-serif;
}

@media (min-width: 481px) {
  .card {
    width: 440px;
  }
  .card img {
    width: 400px;
  }
}

@media (min-width: 768px) {
  .card {
    width: 90%;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -ms-flex-direction: row;
    flex-direction: row;
    -ms-flex-pack: distribute;
    justify-content: space-around;
    margin-top: 30px;
    padding: 25px;
    border-radius: 15px;
    -webkit-box-shadow: 0 0 10px rgba(128, 141, 153, 0.3);
    box-shadow: 0 0 10px rgba(128, 141, 153, 0.3);
  }
  .card:nth-child(2) {
    -webkit-box-orient: horizontal;
    -webkit-box-direction: reverse;
    -ms-flex-direction: row-reverse;
    flex-direction: row-reverse;
  }
  .card img {
    width: 320px;
  }
  .info {
    -webkit-box-align: start;
    -ms-flex-align: start;
    align-items: flex-start;
    text-align: left;
  }
}

@media (min-width: 1024px) {
  .description {
    margin-top: 30px;
    width: 410px;
  }
}

@media (min-width: 1200px) {
  .card img {
    width: 40%;
  }
}

@media (min-width: 1440px) {
  .card {
    width: 1300px;
  }
  .card img {
    width: 500px;
  }
}
</style>
